export default __webpack_public_path__ + "static/certificado-fabricacion-ee90230b91e0a523e598241af9036ecb.pdf";